import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.scss';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <h1>Innovative Digital Solutions</h1>
        <p>Creating exceptional mobile and web experiences</p>
        <Link to="/contact" className="cta-button">Get Started</Link>
      </section>

      <section className="cards">
        <h2>Our Products</h2>
        <div className="cards-grid">
          <div className="card">
            <h3>Mobile Apps</h3>
            <p>Native and cross-platform mobile applications that deliver exceptional user experiences.</p>
          </div>
          <div className="card">
            <h3>Web Applications</h3>
            <p>Modern, responsive web applications built with the latest technologies and best practices.</p>
          </div>
          <div className="card">
            <h3>Custom Solutions</h3>
            <p>Tailored software solutions designed to meet specific market needs.</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Explore our Solutions?</h2>
        <p>Check out our very first mobile application; more to come soon!</p>
        <Link to="https://snekup.app" target="_blank" className="cta-button">See SnekUp</Link>
      </section>
    </div>
  );
};

export default Home; 